// Landing page — Hero + a compact "How to Order" strip. Other sections are their own routes.
import { Hero } from "@/components/Hero";
import { OrderProcess } from "@/components/OrderProcess";
import { useSEO } from "@/lib/useSEO";

export const HomePage = () => {
  useSEO({
    description: "Order traditional homemade Andhra pickles — chicken, mutton, prawn, and vegetarian avakaya — made with pure ingredients and delivered fresh across India.",
  });
  return (
    <>
      <Hero />
      <OrderProcess compact />
    </>
  );
};
